import React from 'react';
import { NavLink } from 'react-router-dom'
// import logo from './images/logo.png'

export default class Navbar extends React.Component {
    collapseMenu(){
        document.getElementById("toggler-btn").click();
    }
    render(){
        return (
            <div>
                <div className="logoimage">
                    <img src="images/logo.jpg" className="imglogo" alt="Logo" />
                </div>
                <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
                    <div className="container">
                        {/* <NavLink to="/" className="navbar-brand"><span className="flaticon-auction"></span>PrimeLaw</NavLink> */}
                        <button className="navbar-toggler" id="toggler-btn" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="oi oi-menu"></span> Menu
                        </button> 

                        <div className="navbar-collapse collapse" id="ftco-nav">
                            <ul className="navbar-nav mx-auto" style={{boxShadow: "1px 1px 1px 1px",borderRadius:"6px"}}>
                                <li className="nav-item"><NavLink exact onClick={this.collapseMenu} to="/" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#3A3A3A",fontFamily:"Perpetua Bold"}}><b>Home</b></NavLink></li>
                                <li className="nav-item"><NavLink exact onClick={this.collapseMenu} to="/about" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#3A3A3A",fontFamily:"Perpetua Bold"}}><b>About Ns</b></NavLink></li>
                                <li className="nav-item"><NavLink exact onClick={this.collapseMenu} to="/expertise" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#3A3A3A",fontFamily:"Perpetua Bold"}}><b>Expertise</b></NavLink></li>
                                <li className="nav-item"><NavLink exact onClick={this.collapseMenu} to="/lawyers" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#3A3A3A",fontFamily:"Perpetua Bold"}}><b>Lawyers</b></NavLink></li>
                                <li className="nav-item"><NavLink exact onClick={this.collapseMenu} to="/contact" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#3A3A3A",fontFamily:"Perpetua Bold"}}><b>Contact Us</b></NavLink></li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}